// extracted by mini-css-extract-plugin
export default {"home":"updateQusetions_home__aFIhP","hr":"updateQusetions_hr__kRkDJ"};